import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(filterAssignedCoursesByLanguage),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(loadAssignedCoursesSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(loadAvailableCoursesSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(assignCourseSaga),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(unassignCourseSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(updateAssignedCourseProgressSaga),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(courseSagas);

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { userSelectors } from '../../user/redux/user-reducer';
import { GaiaApolloClient } from '../../gaia-data/apolloClient';
import { getErrorHandler } from '../../gaia-data/init';
import { AssignCourseMutation, AssignedCoursesAndProgressQuery, AvailableCoursesQuery, UnassignCourseMutation } from '../apollo/course-graphql';
import { ASSIGN_COURSE, courseActions, courseSelectors, LOAD_ASSIGNED_COURSES, LOAD_AVAILABLE_COURSES, UNASSIGN_COURSE } from './course-reducer';
import { SET_CURRENT_COURSE_PROGRESS } from '@rosetta/gaia-progress';

// remove all courses from assignedCoursesRaw which are not in the
//  users learningLanguage.  Some special handling for spanish, which
//  is treated the same for both es-419 and es-ES
function filterAssignedCoursesByLanguage(assignedCoursesRaw) {
  var learningLanguage, currentLangAssignedCourses;
  return _regeneratorRuntime.wrap(function filterAssignedCoursesByLanguage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(userSelectors.getLearningLanguage);

        case 2:
          learningLanguage = _context.sent;
          currentLangAssignedCourses = void 0;

          if (learningLanguage.includes('es-')) {
            // all spanish content whether es-419 or es-ES is considered equivalent in gaia-web
            currentLangAssignedCourses = assignedCoursesRaw.filter(function (course) {
              return course.learningLanguage.includes('es-');
            });
          } else {
            currentLangAssignedCourses = assignedCoursesRaw.filter(function (course) {
              return course.learningLanguage === learningLanguage;
            });
          }
          return _context.abrupt('return', currentLangAssignedCourses);

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadAssignedCoursesSaga() {
  var uiLanguage, response, errorStr, currentLangAssignedCourses, coursesAndProgress;
  return _regeneratorRuntime.wrap(function loadAssignedCoursesSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return put(courseActions.setAssignedCoursesAndProgress(null));

        case 3:
          _context2.next = 5;
          return select(userSelectors.getUILanguage);

        case 5:
          uiLanguage = _context2.sent;
          _context2.next = 8;
          return call(GaiaApolloClient.query, {
            query: AssignedCoursesAndProgressQuery,
            variables: { locale: uiLanguage },
            // Needed because Progress-MP doesn't bust the local cache on progress changes.
            fetchPolicy: 'network-only'
          });

        case 8:
          response = _context2.sent;

          if (response.data.assignedCourses) {
            _context2.next = 14;
            break;
          }

          errorStr = 'no assigned courses found';
          _context2.next = 13;
          return call(getErrorHandler(), { message: errorStr });

        case 13:
          return _context2.abrupt('return', _context2.sent);

        case 14:
          _context2.next = 16;
          return filterAssignedCoursesByLanguage(response.data.assignedCourses);

        case 16:
          currentLangAssignedCourses = _context2.sent;
          coursesAndProgress = {
            assignedCourses: currentLangAssignedCourses,
            progress: response.data.progress
          };
          _context2.next = 20;
          return put(courseActions.setAssignedCoursesAndProgress(coursesAndProgress));

        case 20:
          _context2.next = 26;
          break;

        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 26;
          return call(getErrorHandler(), { message: 'loadAssignedCoursesSaga fail: ' + _context2.t0.message });

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 22]]);
}

function loadAvailableCoursesSaga() {
  var learningLanguage, cefr, response, errorStr;
  return _regeneratorRuntime.wrap(function loadAvailableCoursesSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return select(userSelectors.getLearningLanguage);

        case 3:
          learningLanguage = _context3.sent;
          _context3.next = 6;
          return select(userSelectors.getCefr);

        case 6:
          cefr = _context3.sent;
          _context3.next = 9;
          return call(GaiaApolloClient.query, {
            query: AvailableCoursesQuery,
            variables: { locale: learningLanguage, cefr: cefr }
          });

        case 9:
          response = _context3.sent;

          if (response.data.availableCourses) {
            _context3.next = 15;
            break;
          }

          errorStr = 'no available courses found';
          _context3.next = 14;
          return call(getErrorHandler(), { message: errorStr });

        case 14:
          return _context3.abrupt('return', _context3.sent);

        case 15:
          _context3.next = 17;
          return put(courseActions.setAvailableCourses(response.data.availableCourses));

        case 17:
          _context3.next = 23;
          break;

        case 19:
          _context3.prev = 19;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 23;
          return call(getErrorHandler(), { message: 'loadAvailableCoursesSaga fail: ' + _context3.t0.message });

        case 23:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 19]]);
}

function assignCourseSaga(action) {
  var courseIdToAssign, uiLanguage, cefr, response, errorStr, currentLangAssignedCourses, assignedCoursesProgress;
  return _regeneratorRuntime.wrap(function assignCourseSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          courseIdToAssign = action.payload.courseId;
          _context4.next = 4;
          return select(userSelectors.getUILanguage);

        case 4:
          uiLanguage = _context4.sent;
          _context4.next = 7;
          return select(userSelectors.getCefr);

        case 7:
          cefr = _context4.sent;
          _context4.next = 10;
          return call(GaiaApolloClient.mutate, {
            mutation: AssignCourseMutation,
            variables: { courseId: courseIdToAssign, locale: uiLanguage, cefr: cefr }
          });

        case 10:
          response = _context4.sent;

          if (response.data.assignCourse) {
            _context4.next = 16;
            break;
          }

          errorStr = 'problem assigning course ' + courseIdToAssign;
          _context4.next = 15;
          return call(getErrorHandler(), { message: errorStr });

        case 15:
          return _context4.abrupt('return', _context4.sent);

        case 16:
          _context4.next = 18;
          return filterAssignedCoursesByLanguage(response.data.assignCourse);

        case 18:
          currentLangAssignedCourses = _context4.sent;
          _context4.next = 21;
          return select(courseSelectors.getAllAssignedCoursesProgress);

        case 21:
          assignedCoursesProgress = _context4.sent;
          _context4.next = 24;
          return put(courseActions.setAssignedCoursesAndProgress({
            assignedCourses: currentLangAssignedCourses,
            progress: assignedCoursesProgress
          }));

        case 24:
          _context4.next = 30;
          break;

        case 26:
          _context4.prev = 26;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 30;
          return call(getErrorHandler(), { message: 'assignCourseSaga fail: ' + _context4.t0.message });

        case 30:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 26]]);
}

function unassignCourseSaga(action) {
  var courseIdToUnassign, uiLanguage, userId, response, errorStr, currentLangAssignedCourses, assignedCoursesProgress;
  return _regeneratorRuntime.wrap(function unassignCourseSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          courseIdToUnassign = action.payload.courseId;
          _context5.next = 4;
          return select(userSelectors.getUILanguage);

        case 4:
          uiLanguage = _context5.sent;
          _context5.next = 7;
          return select(userSelectors.getUserId);

        case 7:
          userId = _context5.sent;
          _context5.next = 10;
          return call(GaiaApolloClient.mutate, {
            mutation: UnassignCourseMutation,
            variables: { courseId: courseIdToUnassign, locale: uiLanguage, userId: userId }
          });

        case 10:
          response = _context5.sent;

          if (response.data.deleteCourses) {
            _context5.next = 16;
            break;
          }

          errorStr = 'problem unassigning course ' + courseIdToUnassign;
          _context5.next = 15;
          return call(getErrorHandler(), { message: errorStr });

        case 15:
          return _context5.abrupt('return', _context5.sent);

        case 16:
          _context5.next = 18;
          return filterAssignedCoursesByLanguage(response.data.deleteCourses);

        case 18:
          currentLangAssignedCourses = _context5.sent;
          _context5.next = 21;
          return select(courseSelectors.getAllAssignedCoursesProgress);

        case 21:
          assignedCoursesProgress = _context5.sent;
          _context5.next = 24;
          return put(courseActions.setAssignedCoursesAndProgress({
            assignedCourses: currentLangAssignedCourses,
            progress: assignedCoursesProgress
          }));

        case 24:
          _context5.next = 30;
          break;

        case 26:
          _context5.prev = 26;
          _context5.t0 = _context5['catch'](0);
          _context5.next = 30;
          return call(getErrorHandler(), { message: 'unassignCourseSaga fail: ' + _context5.t0.message });

        case 30:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[0, 26]]);
}

function updateAssignedCourseProgressSaga(action) {
  return _regeneratorRuntime.wrap(function updateAssignedCourseProgressSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return put(courseActions.updateAssignedCourseProgress(action.payload.currentCourseProgress));

        case 3:
          _context6.next = 9;
          break;

        case 5:
          _context6.prev = 5;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 9;
          return call(getErrorHandler(), { message: 'updateAssignedCourseProgressSaga fail: ' + _context6.t0.message });

        case 9:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[0, 5]]);
}

export function courseSagas() {
  return _regeneratorRuntime.wrap(function courseSagas$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return takeLatest(LOAD_ASSIGNED_COURSES, loadAssignedCoursesSaga);

        case 2:
          _context7.next = 4;
          return takeLatest(LOAD_AVAILABLE_COURSES, loadAvailableCoursesSaga);

        case 4:
          _context7.next = 6;
          return takeLatest(SET_CURRENT_COURSE_PROGRESS, updateAssignedCourseProgressSaga);

        case 6:
          _context7.next = 8;
          return takeLatest(ASSIGN_COURSE, assignCourseSaga);

        case 8:
          _context7.next = 10;
          return takeLatest(UNASSIGN_COURSE, unassignCourseSaga);

        case 10:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}